/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'couch-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M16.286 12.495v1.581a2.5 2.5 0 01-2.5 2.5H6.214a2.5 2.5 0 01-2.5-2.5v-1.582a2.284 2.284 0 01-1.667-1.756 2.297 2.297 0 01.839-2.274 2.282 2.282 0 013.339.599c.226.363.346.783.346 1.212v2.864a.573.573 0 00.572.573.57.57 0 00.571-.573v-2.291h4.572v2.291a.573.573 0 00.571.573.57.57 0 00.572-.573v-2.864a2.296 2.296 0 011.28-2.057 2.28 2.28 0 013.15 1.263 2.297 2.297 0 01-.49 2.375c-.294.31-.67.531-1.083.639zM7.664 9.701h4.672a3.44 3.44 0 011.166-2.052 3.423 3.423 0 012.212-.813h.265a.278.278 0 00.307-.279v-.294c0-.76-.301-1.488-.837-2.025a2.854 2.854 0 00-2.02-.84H6.57c-.757 0-1.484.303-2.02.84a2.868 2.868 0 00-.837 2.025v.301a.28.28 0 00.307.28h.265c.809 0 1.591.286 2.21.81a3.44 3.44 0 011.168 2.047z" _fill="#1F222C"/>'
  }
})
